// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\user\\AppData\\Roaming\\npm\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-align {\r\n  height: 35px !important;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
